import React, { useState, useContext, useEffect } from "react";

import { AppContext } from "../context/useAppContext";
import { MemoGalleryItem } from "./GalleryItem";
import Modal from "./Modal";
import { TwitterPicker } from "react-color";

export const Gallery = () => {
  const [appState, setAppState] = useContext(AppContext);
  const [selectedIcons, setSelectedIcons] = useState([]);
  const [renderIcons, setRenderIcons] = useState([{}]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [color, setColor] = useState("#000");
  //const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(!showModal);
  };

  useEffect(() => {
    setSelectedIcons([]);
    setAppState({
      ...appState,
      selectedCategoryIcons: appState.icons,
    });
    setSelectedIndex(0);
    setRenderIcons(appState.icons);
    //setSearchFilter("");

    // console.log("renderICons ", appState.icons);
     // eslint-disable-next-line
  }, []);

  const handleChangeComplete = (color) => {
    setColor(color.hex);
    setAppState((appState) => ({
      ...appState,
      iconToPreviewColor: color || "#000",
    }));
  };

  useEffect(() => {
    if (selectedIcons.length === 0) {
      if (appState.selectedCategory !== "All Icons") {
        let regex = new RegExp(appState.selectedCategory + "/", "g");
        const selected = appState.icons.filter((item) =>
          item.path.match(regex)
        );
        setSelectedIcons(selected);
      } else {
        setSelectedIcons(appState.selectedCategoryIcons);
      }
    } else {
      setRenderIcons(appState.selectedCategoryIcons);
      //   console.log("..... ", appState.selectedCategoryIcons);
      //setRenderIcons(selectedIcons);
    }
     // eslint-disable-next-line
  }, [appState.selectedCategoryIcons]);

  useEffect(() => {
    setSelectedIndex(0);
    setAppState((appState) => ({
      ...appState,
      iconToPreview: renderIcons[0] || {},
    }));
     // eslint-disable-next-line
  }, [renderIcons]);

  useEffect(() => {
    //console.log(".................", renderIcons[selectedIndex]);
    if (renderIcons[selectedIndex].svg) {
      let _renderIcon = renderIcons[selectedIndex].svg;
      let fill = `<svg fill='${color}'`;
      let _newRenderIcon = _renderIcon.replace(/<svg/, fill);
      let _newObject = { ...renderIcons[selectedIndex], svg: _newRenderIcon };
      setAppState((appState) => ({
        ...appState,
        iconToPreview: _newObject,
      }));
    }
     // eslint-disable-next-line
  }, [selectedIndex, color]);

  //   // FILTER RENDER ICONS WITH SEARCH PARAMS
  //   useEffect(() => {
  //     if (searchFilter !== "") {
  //       const filtered = selectedIcons.filter((icon) =>
  //         icon.name.toLowerCase().includes(searchFilter.toLowerCase())
  //       );
  //       setRenderIcons(filtered);
  //     } else {
  //       setRenderIcons(selectedIcons);
  //     }
  //   }, [searchFilter]);

  return (
    <>
      <div className="flex  p-2 w-full justify-between space-x-0">
      
        <div>
          {/* <button
            onClick={() => {
              setDisplayColorPicker(!displayColorPicker);
            }}
            className="flex align-middle justify-items-end p-2 bg-blue-300 rounded-md hover:bg-blue-500 text-white font-semibold  transition-all duration-200 ease-in-out"
          >
            {displayColorPicker ? "X" : "Select Color"}
          </button>
          {displayColorPicker && (
            <SketchPicker
              className="absolute right-0"
              color={color}
              onChange={handleChangeComplete}
            />
          )} */}
          <TwitterPicker
              className="absolute right-0"
              color={color}
              onChange={handleChangeComplete}
            />
        </div>
      </div>
      <section className="prd-gallery flex items-center justify-center">
        <div className="flex flex-wrap gap-6 justify-center">
          {renderIcons.map((item = {}, index) => (
            <MemoGalleryItem
              key={index}
              name={item.name}
              size={appState.size}
              color={color}
              svg={item.svg}
              selected={index === selectedIndex}
              onClick={() => {
                setSelectedIndex(index);
                setShowModal(true);
              }}
            />
          ))}
        </div>
      </section>
      <Modal openModal={openModal} showModal={showModal} />
    </>
  );
};
